import { UserIcon } from '@heroicons/react/24/outline'
import { logout } from '@auth/keycloak'

export default function UserProfileMenu() {
  return (
    <div className="flex-none">
      <div className="dropdown dropdown-end">
        <div
          tabIndex={0}
          role="button"
          className="btn btn-ghost btn-circle avatar"
        >
          <UserIcon className="h-6 w-6" />
        </div>
        <ul
          tabIndex={-1}
          className="menu dropdown-content bg-base-200 rounded-b-box gap-1 z-1 mt-3 w-52 p-2 shadow"
        >
          <li>
            <button
              className="btn btn-sm btn-error btn-outline"
              type="button"
              onClick={logout}
            >
              Abmelden
            </button>
          </li>
        </ul>
      </div>
    </div>
  )
}
